import {Card, Grid, Heading} from '@primer/react-brand/esm'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import type {ImageLinkItem} from '../../types'
import {getAssetImageStyle, renderWithoutParagraphs} from '../../utils'
import type {Document} from '@contentful/rich-text-types'

export type FlexSuiteLargeCardsProps = {
  heading?: Document
  cards?: ImageLinkItem[]
}

export function FlexSuiteLargeCards({heading, cards}: FlexSuiteLargeCardsProps) {
  if (!cards?.length) return null

  return (
    <Grid>
      {heading && (
        <Grid.Column span={12}>
          <Heading as="h3">{renderWithoutParagraphs(heading)}</Heading>
        </Grid.Column>
      )}
      {cards.map(c => {
        const id = c.sys.id
        const card = c.fields
        const imageUrl = card.image?.fields.file.url
        const imageStyle = getAssetImageStyle(card.image)

        return (
          <Grid.Column span={{xsmall: 12, small: 10, large: 4}} start={{small: 2}} key={id}>
            <Card
              href={card.href}
              fullWidth
              hasBorder
              backgroundColor="default"
              ctaVariant="arrow"
              ctaText={card.label}
            >
              {card.eyebrow && <Card.Label>{card.eyebrow}</Card.Label>}
              {card.heading && (
                <Card.Heading>
                  {renderWithoutParagraphs(card.heading)}
                  {card.alt ? <span className="sr-only"> {card.alt}</span> : null}
                </Card.Heading>
              )}
              {card.description && <Card.Description>{renderWithoutParagraphs(card.description)}</Card.Description>}
              {imageUrl && (
                <Card.Image
                  as="picture"
                  aspectRatio={imageStyle ? 'custom' : undefined}
                  style={imageStyle}
                  src={`${imageUrl}?fm=webp`}
                  alt={card.image?.fields.description || ''}
                  sources={getImageSources(imageUrl, {maxWidth: MAX_CONTENT_WIDTH / 3})}
                  position="block-end"
                  padding="none"
                  loading="lazy"
                />
              )}
            </Card>
          </Grid.Column>
        )
      })}
    </Grid>
  )
}
